export const abacusApp = {
  id: 91,
  name: "abacus",
  label: "Abacus",
  areaBlacklist: ["productSelection", "journal", "migration"],
  disableAdvancedSettings: true,
  logo: process.env.BASE_URL + "media/shopLogos/abacus.svg",
  additional_params: {
    requestHeaders: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: {
      grant_type: "client_credentials"
    },
    endpoint: "/oauth/oauth2/v1/token",
    requestMethod: "POST",
    authType: "basic"
  },
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_ABACUS_PRESET_ID
  }
};
